import React from 'react'

import { css, styled } from '../../../styled'

const track = (isWebkit?: boolean) => css`
  box-sizing: border-box;
  border: none;
  width: 100%;
  height: 0.25em;
  background: rgba(255, 255, 255, 0.2);

  ${isWebkit && // webkit用のツマミ前の塗り
  css`
    ${({ value, min, max }: Props) => css`
      background: linear-gradient(#0080ff, #0080ff) 0 /
        calc(
          0.5 * 12px + calc(${value} - ${min}) / calc(${max} - ${min}) *
            (100% - 12px)
        )
        100% no-repeat rgba(255, 255, 255, 0.2);
    `};
  `};
`

const fillLower = () => css`
  height: 0.25em;
  background: #0080ff;
`

const thumb = () => css`
  box-sizing: border-box;
  border: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
`

const Range = styled.input`
  font: 1em/1 arial, sans-serif;
  width: ${({ width }) => `${width}px`};
  height: 12px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  background: transparent;
  appearance: none;

  &:focus {
    outline: none;
  }

  /* ベースライン */
  &::-webkit-slider-runnable-track {
    ${track(true)};
  }
  &::-moz-range-track {
    ${track()};
  }
  &::-ms-track {
    ${track()};
    height: 0;
  }

  /* ツマミ前の塗り */
  &::-moz-range-progress {
    ${fillLower()};
  }
  &::-ms-fill-lower {
    ${fillLower()};
  }

  /* ツマミ */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    margin-top: -4px;
    ${thumb()};
  }
  &::-moz-range-thumb {
    ${thumb()};
  }
  &::-ms-thumb {
    margin-top: 0;
    ${thumb()};
  }

  /* ツールチップ */
  &::-ms-tooltip {
    display: none;
  }
`

type Props = {
  className?: string
  max?: number
  min?: number
  onChange: React.ChangeEventHandler<HTMLElement>
  onTouchEnd?: () => void
  onTouchStart?: () => void
  step?: number
  value: number
  width?: number
}

export const ProgressBar: React.FC<Props> = ({
  className,
  max = 1,
  min = 0,
  onChange,
  onTouchEnd,
  onTouchStart,
  step,
  value,
  width = 100,
}) => (
  <Range
    className={className}
    max={max}
    min={min}
    onChange={onChange}
    onTouchEnd={onTouchEnd}
    onTouchStart={onTouchStart}
    step={step}
    value={value}
    width={width}
    type="range"
  />
)
